import Auth from '@/helpers/authorizations'
import Management from '@/layouts/Management'

export default {
  path: '/magcard_swipe_records',
  component: Management,
  redirect: '/magcard_swipe_records/list',
  children: [
    // 列表页
    {
      path: 'list',
      component: () => import('@/views/magcard_swipe_records/List'),
      meta: {
        auth: Auth.listMagcardSwipeRecords
      }
    }
  ]
}
